import React, { Component } from 'react'
import i18n from 'simple-react-i18n'
import AppStore from '../../../../store/AppStore'
import ToastrAction from '../../../../toastr/actions/ToastrAction'
import { uniq } from 'lodash'
import AdesStationDto from '../../../dto/AdesStationDto'
import Table from '../../../../components/datatable/Table'
import { nbPerPageLabelTiny } from '../../../../referencial/constants/ReferencialConstants'
import { Grid } from '@mui/material'
import Select from '../../../../components/forms/Select'
import Input from '../../../../components/forms/Input'
import Checkbox from '../../../../components/forms/Checkbox'
import RadioButtons from '../../../../components/forms/RadioButtons'
import PropTypes from 'prop-types'
import Job from '../../../dto/DtoJob'
import { arrayOf } from '../../../../utils/StoreUtils'
import NetworkDto from '../../../../referencial/components/network/dto/NetworkDto'
import { connect } from 'react-redux'
import { getIntegrationModes } from '../../../../utils/JobUtils'
import { readImportCsvStationsCodes } from '../../utils/ImportUtils'
import IntegrationModeDialog from '../IntegrationModeDialog'

class SieauInstancePanel extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        const filters = this.getFilters()
        this.onChangeFilters({
            importType: 'piezometry',
            updateStation: true,
            validOnly: true,
            dataIntegrationMode: 'DATA_ADD_LAST_DATA',
            codes: [],
            ...filters,
        })
    }

    onDeleteBssCode = ({ bsscode }) => {
        if (this.props.isEditMode) {
            const filters = this.getFilters()
            this.onChangeFilters({ codes: filters.codes.filter(p => p !== bsscode) })
        }
    }

    addBssCode = () => {
        if (this.props.isEditMode) {
            const filters = this.getFilters()
            const code = this.refs.txtAddBssCode.value
            const exist = filters.codes.find(p => p.toLowerCase() == code.toLowerCase())
            if (!code) {
                AppStore.dispatch(ToastrAction.error(i18n.youMustEnterAtLeastOneBssCode))
            } else if (exist) {
                AppStore.dispatch(ToastrAction.error(i18n.youHaveAlreadyEnteredThisBssCode))
            } else {
                this.onChangeFilters({ codes: [ code, ...filters.codes ] })
                this.refs.txtAddBssCode.value = ''
            }
        }
    }

    onChangeBssFile = e => {
        if (this.props.isEditMode) {
            readImportCsvStationsCodes(e, this.refs, (codes) => {
                const filters = this.getFilters()
                this.onChangeFilters({ codes: uniq([ ...filters.codes, ...codes ]) })
            })
        }
    }

    getStations = () => {
        const filters = this.getFilters()
        return (filters.codes || []).map(bsscode => new AdesStationDto({ bsscode }))
    }

    onChangeFilters = (changes) => {
        const parameters = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                ...changes,
            })],
        }
        this.props.onChangeJob({ parameters })
    }

    getFilters = () => {
        return this.props.job.parameters.filters.length ? JSON.parse(this.props.job.parameters.filters[0]) : {}
    }

    getStationsPanel = () => {
        const disabled = { disabled: !this.props.isEditMode }
        return (
            <div>
                <Grid container sx={{ alignItems: 'center' }}>
                    <Grid size={3}>
                        <label>{ i18n.importFile }</label>
                    </Grid>
                    <Grid container size={9} className='file-field input-field' sx={{ padding: 0 }}>
                        <Grid size={3} className='btn' sx={{ padding: 0 }}>
                            <span>{ i18n.importLabel }</span>
                            <input
                                type='file'
                                ref='importFile'
                                accept='.csv'
                                onChange={ this.onChangeBssFile }
                                {...disabled}
                            />
                        </Grid>
                        <Grid size={9} className='file-path-wrapper'>
                            <input
                                className='file-path'
                                ref='fileInput'
                                type='text'
                                placeholder={ i18n.selectedFile }
                                {...disabled}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container sx={{ marginBottom: '20px', alignItems: 'center' }}>
                    <Grid size={3}>
                        <label>{ i18n.addCredential }</label>
                    </Grid>
                    <Grid container size={9} className='input-field' sx={{ padding: 0 }}>
                        <Grid size={8}>
                            <input id='txtAddBssCode' type='text' placeholder={ i18n.BSSExample } ref='txtAddBssCode'/>
                            <label className='tinyLabel'>{ i18n.theCodeMustBePresentInTheRepositoryAndDefinedByTheCode }</label>
                        </Grid>
                        <Grid
                            component='a'
                            size={3}
                            offset={1}
                            className='waves-effect waves-light btn'
                            onClick={ this.addBssCode }
                        >
                            { i18n.add }
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container sx={{ marginBottom: '20px', alignItems: 'center' }}>
                    <Grid size={12}>
                        <Table
                            type={ new AdesStationDto() }
                            data={ this.getStations() }
                            title={ i18n.credentials }
                            nbPerPageLabel={ nbPerPageLabelTiny }
                            onDelete={ this.onDeleteBssCode }
                            deletable={ this.props.isEditMode }
                            showNbElements
                            activeHeader
                            paging
                            exportButtonOnHeader
                        />
                    </Grid>
                </Grid>
            </div>
        )
    }

    render() {
        const disabled = { disabled: !this.props.isEditMode }

        const importType = [
            { code: 'piezometry', name: i18n.piezometry },
        ]
        const validRadioElements = [
            { code: true, name: i18n.yes },
            { code: false, name: i18n.no },
        ]
        const filters = this.getFilters()
        return (
            <div>
                <Grid container spacing={1} sx={{ alignItems: 'center' }}>
                    <Grid size={2}>
                        <Select
                            label={i18n.importMode}
                            options={importType}
                            value={filters.importType}
                            onChange={v => this.onChangeFilters({ importType: v })}
                            { ...disabled }
                        />
                    </Grid>
                    <Grid size={3}>
                        <Checkbox
                            checked={ filters.updateStation }
                            label={ i18n.integrateStationInfo }
                            onChange={ v => this.onChangeFilters({ updateStation: v }) }
                            { ...disabled }
                        />
                    </Grid>
                    <Grid size={4}>
                        <Select options={ getIntegrationModes() } label={ i18n.dataIntegration } value={ filters.dataIntegrationMode } labelSpan={ <IntegrationModeDialog /> }
                            onChange={ v => this.onChangeFilters({ dataIntegrationMode: v }) }
                            { ...disabled }
                        />
                    </Grid>
                    <Grid size={3}>
                        <RadioButtons
                            elements={ validRadioElements }
                            selected={ filters.validOnly }
                            onChange={ v => this.onChangeFilters({ validOnly: v }) }
                            { ...disabled }
                            title={ i18n.validData }
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid size={4}>
                        <Input title={ 'URL instance' } onChange={ v => this.onChangeFilters({ instanceUrl: v }) } { ...disabled } value={ filters.instanceUrl } />
                    </Grid>
                    <Grid size={4}>
                        <Input title={ i18n.user } onChange={ v => this.onChangeFilters({ user: v }) } { ...disabled } value={ filters.user } />
                    </Grid>
                    <Grid size={4}>
                        <Input title={ i18n.password } onChange={ v => this.onChangeFilters({ password: v }) } { ...disabled } value={ filters.password } passwordType/>
                    </Grid>
                </Grid>
                { this.getStationsPanel() }
            </div>
        )
    }
}

SieauInstancePanel.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    addBssCode: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    onChangeDataTypes: PropTypes.func,
    onChangeFilters: PropTypes.func,
    onChangeJob: PropTypes.func,
    networks: arrayOf(NetworkDto),
}

const mapStateToProps = store => ({
    networks: store.NetworkReducer.networks,
})

export default connect(mapStateToProps)(SieauInstancePanel)
